import { createSelector } from 'reselect';

const selectInvitationRoot = (state) => state.invitation;

export const selectInvitationData = createSelector(
    [selectInvitationRoot],
    (invitation) => invitation.data,
);

export const selectInvitationIsLoading = createSelector(
    [selectInvitationRoot],
    (invitation) => invitation.isLoading,
);

export const selectInvitationError = createSelector(
    [selectInvitationRoot],
    (invitation) => invitation.error,
);

export const selectInvitationAcceptStatus = createSelector(
    [selectInvitationRoot],
    (invitation) => invitation.acceptStatus,
);
